export const splitSeparator = '&#8226;';

export default {};
